<template>
  <master-main
    :addProperties="{
      isWizard: false,
    }"
    :exportProperties="{
      pdf: {
        filename: `${$t('samples.ground_types')}.pdf`,
        route: `${getModuleRoute}/pdf`,
      },
      xls: {
        filename: `${$t('samples.ground_types')}.xlsx`,
        route: `${getModuleRoute}/excel`,
      },
    }"
    :route="getModuleRoute"
    :showProperties="showProperties"
    :tableProperties="tableProperties"
    @closeModal="handleCloseModal"
    @openModal="handleOpenModal"
    @refresh="refresh"
    @showHideLoading="showHideLoading"
    @showNotification="notifyVue"
    @submitUpload="submitUpload"
    ref="masterMain"
  >
    <template slot="dialogForm">
      <edit-create
        :syncDialog="modals"
        @addEdit="addEdit"
        @closeModal="handleCloseModal"
        @showHideLoading="showHideLoading"
        @showNotification="notifyVue"
        ref="editCreate"
        :routeUpload="`${getModuleRoute}/deleteImage`"
      />
    </template>
  </master-main>
</template>
<script>
import EditCreate from 'src/views/Pages/Dashboard/Ground/Types/EditCreate';
import MasterMain from 'src/components/Layouts/Masters/MasterMain.vue';
import MixinAlert from 'src/mixins/mixin-alert';
import MixinLoading from 'src/mixins/mixin-loading';
import MixinForm from 'src/mixins/forms/mixin-form';
import MixinMain from 'src/mixins/master/mixin-main';
import MixinPermissions from 'src/util/mixinPermissions';
import MixinWithDialog from 'src/mixins/master/mixin-with-dialog';
import SoilTypeTable from './soil-type-table';

export default {
  components: { MasterMain, [EditCreate.name]: EditCreate },
  data() {
    return {
      tableProperties: {},
      showProperties: { size: '70%' },
    };
  },
  mixins: [
    MixinAlert,
    MixinLoading,
    MixinMain,
    MixinPermissions,
    MixinWithDialog,
    MixinForm,
  ],
  computed: {
    getModuleRoute() {
      return 'grounds/types';
    },
    buildTableProperties() {
      return {
        tableColumns: [...SoilTypeTable().tableColumns],
        model: 'soiltype',
        effectTags: 'dark',
        showColumnImage: true,
        widthColumnStatus: 160,
        widthOperations: 110,
        defaultSort: { prop: 'code', order: 'ascending' },
      };
    },
  },
  methods: {
    submitUpload(registerId) {
      this.$refs.editCreate.submitUpload(registerId);
    },
  },
};
</script>
